export const regionsQuery = `{
  regions {
    id
    name
  }
}`
